module.exports = __webpack_public_path__ + "img/face-neutral.b5cad438.svg";